/**
 * The screens that have left the legacy react-router tree.
 *
 * One list, two consumers that would otherwise drift apart:
 *
 *  - `components/layout/nav-items.ts` uses it to decide whether a sidebar entry
 *    can be a typed `<Link>` or still needs `LegacyLink`.
 *  - `routes/seam.test.ts` uses it to assert these paths resolve to their own
 *    route and are NOT swallowed by the catch-all.
 *
 * Deliberately dependency-free. The seam test must not pull the app's module
 * graph in behind it, and nav-items must stay cheap.
 *
 * Add a path here in the same commit that adds its route file. If you add one
 * that has no route, `<Link to>` in AppSidebar stops typechecking — that is the
 * list keeping itself honest.
 */
export const MIGRATED_PATHS = [
  "/mcps",
  "/blueprints",
  "/api-keys",
  "/platform/security/api-keys",
  "/playground",
  "/ai-catalog",
  "/usage",
  "/projects",
  "/deployments/overview", // Bookmark compatibility: redirects to the legacy /deployments landing page.
  "/deployments/new",
  "/deployments/fast-switch",
  "/deployments/observability",
] as const;

export type MigratedPath = (typeof MIGRATED_PATHS)[number];

export const isMigratedPath = (to: string): to is MigratedPath =>
  (MIGRATED_PATHS as readonly string[]).includes(to);
